import { render, staticRenderFns } from "./StockOrderFilters.vue?vue&type=template&id=6eede65f"
import script from "./StockOrderFilters.vue?vue&type=script&lang=ts"
export * from "./StockOrderFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports